<template>
  <a-modal
    :title="title"
    :visible="open"
    :confirm-loading="uploading"
    @cancel="importExcelHandleCancel"
    @ok="importExcelHandleChange"
  >
    <a-spin tip="上传中..." :spinning="uploading">
      <a-upload-dragger
        name="file"
        accept=".xlsx, .xls"
        :file-list="fileList"
        :multiple="false"
        :remove="handleRemove"
        :before-upload="beforeUpload"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">
          请将文件拖拽到此处上传
        </p>
        <p class="ant-upload-hint">
          支持 .xlsx / .xls。列顺序：设备类型、设备序列号、蓝牙MAC地址、设备图片URL（第4列填写图片链接）
        </p>
      </a-upload-dragger>
      <a-alert
        type="info"
        show-icon
        style="margin-top: 12px"
        message="序列号规范"
        description="蓝牙MAC：AA:BB:CC:DD:EE:FF；序列号 = MP + 去掉冒号的12位MAC，例如 98:A3:16:E7:8B:D2 → MP98A316E78BD2。"
      />
      <a-checkbox @change="handleCheckedUpdateSupport" :checked="updateSupport != 0" style="margin-top: 12px">
        是否更新已存在的设备（按蓝牙MAC+序列号匹配）
      </a-checkbox>
      <div style="margin-top: 8px">
        <a @click="importTemplate">下载导入模板</a>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import { importDeviceStock } from '@/api/mibo/deviceStock'

export default {
  name: 'ImportExcel',
  data () {
    return {
      title: '设备导入',
      open: false,
      fileList: [],
      uploading: false,
      updateSupport: 0
    }
  },
  methods: {
    importExcelHandleCancel () {
      this.open = false
      this.fileList = []
      this.$emit('ok')
    },
    importTemplate () {
      this.download('mibo/device-stock/importTemplate', {}, `设备导入模板_${new Date().getTime()}.xlsx`)
    },
    importExcelHandleOpen () {
      this.open = true
    },
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
    importExcelHandleChange () {
      if (!this.fileList.length) {
        this.$message.warning('请先选择要导入的文件')
        return
      }
      this.uploading = true
      const uploadFile = this.fileList[0]
      const rawFile = uploadFile.originFileObj || uploadFile
      const formData = new FormData()
      formData.append('file', rawFile)
      formData.append('updateSupport', this.updateSupport)
      importDeviceStock(formData).then(response => {
        if (response.success || response.code === 1 || response.code === 20001) {
          this.fileList = []
          this.$message.success(response.message || response.msg || '导入成功')
          this.open = false
          this.$emit('ok')
        } else {
          this.$message.error(response.message || response.msg || '导入失败')
        }
      }).finally(() => {
        this.uploading = false
      })
    },
    handleCheckedUpdateSupport () {
      this.updateSupport = this.updateSupport === 0 ? 1 : 0
    },
    handleRemove () {
      this.fileList = []
      this.uploading = false
    }
  }
}
</script>
